export const fetchSeoHeadInfos = async ({ seoModel, page, pageSize, order, language, bffUri, }) => {
    // flag to prevent fetching during parallelism
    if (!seoModel)
        return {};
    const response = await fetch([bffUri, 'seo/headinfos'].join(''), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
        },
        body: JSON.stringify({
            properties: {},
            locale: language,
            criteria: seoModel,
            paging: {
                order,
                page,
                size: pageSize,
            },
        }),
        signal: AbortSignal.timeout(5000),
    });
    if (response.ok) {
        return (await response.json());
    }
    return {};
};
